import type { ResendVerificationRequestDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export function useResendVerification() {
  return useApiMutation(
    "post",
    "/auth/resend-verification",
    {
      notify: false,
      mapVariables: (data: ResendVerificationRequestDto) => ({
        body: data,
        headers: {
          "x-auth-request": "true",
        },
      }),
    },
  );
}
